export const getDateLimits = (originalDate = new Date(), view = 'month') => {
    const limits = {};
    let date = !!originalDate instanceof Date ? originalDate : new Date(originalDate);
    switch (view) {
        case 'agenda':
            limits.startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
            limits.endDate   = new Date(date.getFullYear(), date.getMonth() + 1, 6);
            break;

        case 'day':
            limits.startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
            limits.endDate   = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
            break;

        case 'week':
            limits.startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 6);
            limits.endDate   = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 6);
            break;

        case 'month':
        default:
            limits.startDate = new Date(date.getFullYear(), date.getMonth(), -6);
            limits.endDate   = new Date(date.getFullYear(), date.getMonth() + 1, 6);
            break;
    }

    return limits;
};

export const getISODateLimits = (date = new Date(), view = 'month') => {
    const { startDate, endDate } = getDateLimits(date, view);
    return {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString()
    };
};

export const asDate = (originalDate, defaultValue = null) => {
    if (!originalDate) { return defaultValue; }

    if (originalDate instanceof Date) {
        return originalDate;
    } else {
        return new Date(originalDate);
    }
};

